(function() {
    'use strict';

    angular
        .module('atheer.copilot', [

        ]);
})();
